import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import { Toaster } from "./components/ui/sonner";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Cases from "./pages/Cases";
import CreateCase from "./pages/CreateCase";
import CaseIntake from "./pages/CaseIntake";
import CaseDetail from "./pages/CaseDetail";
import Documents from "./pages/Documents";
import ProcessingReview from "./pages/ProcessingReview";
import FieldValidation from "./pages/FieldValidation";
import KnowledgeBase from "./pages/KnowledgeBase";
import DraftGenerator from "./pages/DraftGenerator";
import ReviewWorkspace from "./pages/ReviewWorkspace";
import Approvals from "./pages/Approvals";
import Exports from "./pages/Exports";
import AuditLogs from "./pages/AuditLogs";
import Compliance from "./pages/Compliance";
import Settings from "./pages/Settings";

import "./App.css";

function Protected({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/login" element={<Login />} />

          <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
          <Route path="/cases" element={<Protected><Cases /></Protected>} />
          <Route path="/cases/new" element={<Protected><CaseIntake /></Protected>} />
          <Route path="/cases/new/manual" element={<Protected><CreateCase /></Protected>} />
          <Route path="/cases/:caseId" element={<Protected><CaseDetail /></Protected>} />
          <Route path="/cases/:caseId/documents" element={<Protected><Documents /></Protected>} />
          <Route path="/cases/:caseId/processing" element={<Protected><ProcessingReview /></Protected>} />
          <Route path="/cases/:caseId/fields" element={<Protected><FieldValidation /></Protected>} />
          <Route path="/cases/:caseId/draft" element={<Protected><DraftGenerator /></Protected>} />
          <Route path="/cases/:caseId/review/:draftId" element={<Protected><ReviewWorkspace /></Protected>} />

          <Route path="/documents" element={<Protected><Documents /></Protected>} />
          <Route path="/processing" element={<Protected><ProcessingReview /></Protected>} />
          <Route path="/draft" element={<Protected><DraftGenerator /></Protected>} />
          <Route path="/review" element={<Protected><ReviewWorkspace /></Protected>} />

          <Route path="/knowledge" element={<Protected><KnowledgeBase /></Protected>} />
          <Route path="/approvals" element={<Protected><Approvals /></Protected>} />
          <Route path="/exports" element={<Protected><Exports /></Protected>} />
          <Route path="/audit" element={<Protected><AuditLogs /></Protected>} />
          <Route path="/compliance" element={<Protected><Compliance /></Protected>} />
          <Route path="/settings" element={<Protected><Settings /></Protected>} />

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}
